export const SET_TWITCH_STREAMING = 'SYNC_TWITCH_SET_TWITCH_STREAMING'
export const SET_TWITCH_NAME = 'SYNC_TWITCH_SET_TWITCH_NAME'
export const SET_TWITCH_URL = 'SYNC_TWITCH_SET_TWITCH_URL'
export const UPDATE_TWITCH = 'SYNC_TWITCH_UPDATE_TWITCH_STATUS'



// WEBPACK FOOTER //
// ./src/features/Sync/data/twitch/constants.js